import { ToastContainer, toast } from 'react-toastify';

import { Link, useLocation } from "react-router-dom";
import loading from "../../assets/images/loading.gif"
import { useState, useEffect } from "react";
import { makeGetRequest } from "../../request";
import { useSelector } from "react-redux";
import { customStyles, exportToExcel, getCurrencySymbol } from "../../helpers";
import Pagination from "../../components/Pagination";
import Layout from '../Layout';
import Modal from "react-modal"

const FreightForwarderReport =  () => {
    // VARIABLE DEFINITIONS
    const user:any = useSelector((state: any) => state.tepngUser.value);
    const location = useLocation()
    const statusBeforeNavigation = location.state as { status: number };
    const [records, setRecords] = useState<Record <string, any>>([])
    const [reportTable, setReportTable] = useState<Record <string, any>>([])
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(25);
    const [totalItems, setTotalItems] = useState(0);      
    const [searchValue, setSearchValue] = useState("")
    const [isLoading, setIsLoading] = useState(false)
    const [comment, ] = useState("")
    const [openModal, setOpenModal] = useState(false)

    // FUNCTIONS
    const totalPages = Math.ceil(totalItems / itemsPerPage);
    const [startIndex, setStartIndex] = useState(0);
    const getPageNumbers = () => {
        return Array.from({ length: totalPages }, (_, i) => i + 1);
    };

    const handleNext = () => {
        if (currentPage < totalPages) {
            setCurrentPage(currentPage + 1);
            if (currentPage >= startIndex + 4) {
                setStartIndex(startIndex + 4);
            }
        }
    };

    const handlePrevious = () => {
        if (currentPage > 1) {
            setCurrentPage(currentPage - 1);
            if (currentPage - 1 <= startIndex) {
                setStartIndex(startIndex - 4);
            }
        }
    };
    
    const handleSearch = (event: any) => {
        const value = event.target.value
        if(!value) setSearchValue("")
    }

    const [status, ] = useState<number|null>(statusBeforeNavigation?.status ? statusBeforeNavigation?.status : 1)
    const getRecords = () => {
        setIsLoading(true)
        var request: Record<string, any> = {
            what: "getFreightForwarderReport",
            params: {
                Page: currentPage,
                PageSize: itemsPerPage,
                FreightForwarderId: user?.id
            }
        };
        if(searchValue) { request.params.SearchString = searchValue }
        
        makeGetRequest(request)
            .then((response: any) => {
                setIsLoading(false)
                const res = response.data.data
                setRecords(res)
                setReportTable(res.flatMap((poitem: any) => 
                    poitem.materialItems.map((materialItem: any) => ({
                        mrdNumber: poitem.mrdNumber,
                        purchaseOrderNumber: materialItem.purchaseOrderNumber,
                        purchaseOrderItemRequestNumber: materialItem.purchaseOrderItemRequestNumber,
                        tag: materialItem.tag,
                        quantity: materialItem.quantitySupply,
                        description: materialItem.description,
                        hsCode: materialItem.hsCode,
                        countryOfOrigin: materialItem.countryOfOrigin,
                        currency: materialItem.currency,
                        project: materialItem.project,
                        unitPrice: materialItem.unitPrice,
                    }))
                ))
                setTotalItems(response.data.totalCount)
            })
            .catch((error:any) => 
                toast.error(error.errorMessage)
            );
    }

    // LIST POCS
    const row = records.map((data: any, index: number) => {
                    return (
                        <tr key={index} style={{background: "white"}}>
                            <td style={{borderLeft: "1px solid #d9d9d9", borderRight: "1px solid #d9d9d9"}}>{ currentPage === 1 ? currentPage + index : (((itemsPerPage*currentPage)-itemsPerPage)+1) + index }</td>
                            <td>{ data?.mrdNumber } </td>                            
                            <>
                                <tr style={{borderLeft: "1px solid #d9d9d9", borderRight: "1px solid #d9d9d9",}}>
                                    <th style={{background: "#d9d9d9"}}>PO Number</th>
                                    <th style={{background: "#d9d9d9"}}>Item Number</th>
                                    <th style={{background: "#d9d9d9"}}>Tag</th>
                                    <th style={{background: "#d9d9d9"}}>Qty</th>
                                    <th style={{background: "#d9d9d9"}}>Description</th>
                                    <th style={{background: "#d9d9d9"}}>HS Code</th>
                                    <th style={{background: "#d9d9d9"}}>Origin</th>
                                    <th style={{background: "#d9d9d9"}}>Unit Price</th>
                                    <th style={{background: "#d9d9d9"}}>Currency</th>
                                    <th style={{background: "#d9d9d9"}}>Project</th>
                                </tr>
                                {
                                    data?.materialItems.map((materialItem: any, index: number) => {
                                        return (
                                            <tr key={index} style={{borderLeft: "1px solid #d9d9d9", borderRight: "1px solid #d9d9d9"}}>
                                                <td>{ materialItem?.purchaseOrderNumber }</td>
                                                <td>{ materialItem?.purchaseOrderItemRequestNumber }</td>
                                                <td>{ materialItem?.tag }</td>
                                                <td>{ materialItem?.quantitySupply }</td>
                                                <td>{ materialItem?.description }</td>
                                                <td>{ materialItem?.hsCode }</td>
                                                <td>{ materialItem?.countryOfOrigin }</td>
                                                <td>{getCurrencySymbol(materialItem?.currency)}{ materialItem?.unitPrice }</td>
                                                <td>{ materialItem?.currency }</td>
                                                <td>{ materialItem?.project }</td>
                                            </tr>
                                            
                                        )
                                    })
                                }
                            </>                            
                            <td>
                                <Link to={"/freightforwarder/materialreadinessdocument/"+data?.id} state={{status: status, origin: "/freightforwarder/report"}} className="actions">
                                    <span className="material-symbols-rounded">pageview</span>
                                    <span>View Details</span>
                                </Link>
                            </td>
                        </tr>
                    )
                })

    useEffect(() => {
        getRecords()
        // eslint-disable-next-line
    }, [user, currentPage, itemsPerPage, searchValue, status])

    const page = "Freight Forwarder Report"

    return (
        <Layout title={page}>
            <div className="container">
                <div className="main">
                    <h3 className="page_title">{  }</h3>     
                    <div className="main-inner">
                        <div className="main-inner-top">
                            <div className="d-flex">
                                <div className="search-container left-item">
                                    <span className="material-symbols-rounded">search</span>
                                    <input id="search" placeholder="Search Report" title='Search MRD Number, PO Number,' onKeyUp={handleSearch}  />
                                </div>
                                <button className="custom-button orange left-item ml-2"
                                    onClick={() => {setSearchValue((document.getElementById("search") as HTMLInputElement)?.value); setCurrentPage(1)}}
                                >Search</button>
                            </div>
                            <div className='d-flex' style={{gap: "16px"}}>
                                <button className='custom-button orange' onClick={() => exportToExcel(reportTable)}>
                                    <span className="material-symbols-outlined fw-500">upload</span> Export Report
                                </button>
                            </div>
                        </div>                        

                        <div className='table-container custom'>
                            <table>
                                <thead>
                                    <tr className="no-textwrap">
                                        <th>SN</th>
                                        <th style={{borderLeft: "1px solid #d9d9d9", borderRight: "1px solid #d9d9d9"}}>MRD Number</th>                                      
                                        <th colSpan={8}></th>                                      
                                        {/* <th>Action</th> */}
                                    </tr>
                                </thead>
                                <tbody>
                                    {isLoading ? null : (
                                            records?.length === 0 ? <td className='no-records' colSpan={6}>No Records Found</td>
                                            : row
                                        )
                                    }
                                </tbody>
                            </table>
                            {isLoading ? <div className="loader">
                                        <img src={loading} alt="loading" />
                                        <p>Loading data...</p>
                                    </div> : null}
                            <Modal isOpen={openModal} style={customStyles} className="modal modal-3" ariaHideApp={false}>
                                <div className="modal-header">
                                    <h3 style={{display: "flex", alignItems: "center", gap: "6px"}}>Comment</h3>
                                    <span className="material-symbols-rounded close"
                                        onClick={() => setOpenModal(false)}>close</span>
                                </div>
                                <div className="modal-body" style={{minHeight: "120px", fontSize: "12px"}}>
                                    {comment}
                                </div>
                            </Modal>
                            
                        </div>
                        <div className="pagination-container">
                            <Pagination
                                currentPage={currentPage}
                                itemsPerPage={itemsPerPage}
                                totalPages={totalPages}
                                handlePrevious={handlePrevious}
                                handleNext={handleNext}
                                setCurrentPage={setCurrentPage}
                                getPageNumbers={getPageNumbers}
                                setItemsPerPage={setItemsPerPage}
                                startIndex={startIndex} />
                        </div>
                    </div>                 
                </div>
                <ToastContainer />
            </div>
        </Layout>
    )
}

export default FreightForwarderReport